<template>
  <div class="header">
   <div class="container" >
   
    <div class="page_width">
       <!-- pc header -->
      <div class="header_top flex_center_start hidden-sm-and-down">
        <div class="header_logo pointer" @click="toPage('index')">
          <div class="header_logo_group">
            <img src="../assets/image/logo.png" alt="">
          </div>
        </div>
       
        <div class="header_menu">
         <div class="menu_list flex">
          <div class="menu_tab pointer" v-for="(i) in  menuList" :key="i.id" @click="toPage(i.path)" @mouseenter="getMineMenu(i)" @mouseleave="removeMinMenu(i)">
            {{ i.title }} 
            <span class="icon-down-line-free iconfont" v-if="i.child"></span>
          <div class="min_menu" v-if="i.child">
            <transition name="el-zoom-in-top">
              <div class="min_menu_list" v-show="child_drawer">
                <div class="min_menu_tab pointer" v-for="(child) in  i.child" :key="child.id"  @click="toPage(child.path)" >{{ child.title }}</div>
              </div>
            </transition>
          </div>
          </div>
         </div>
        </div>
      </div>
      <!-- mobile header -->
      <div class="mobile_header flex_sb hidden-md-and-up">
        <div class="header_logo pointer" @click="toPage('index')">
          <div class="header_logo_group">
            <img src="../assets/image/logo.png" alt="">
          </div>
        </div>
        <div class="menu_icon iconfont icon-menu-line flex_center" @click="drawer=!drawer"></div>
        <div class="mobile_menu">
          <transition name="el-zoom-in-top">
            <div class="mobile_menu_list" v-show="drawer">
              <div class="mobile_menu_tab pointer color1" v-for="(i) in  menuList" :key="i.id"  @click="toPage(i.path)" >{{ i.title }}
                <transition name="el-zoom-in-top" v-if="i.child">
                  <div class="min_menu_list "  v-show="child_mobile_drawer" >
                    <div class="min_menu_tab pointer" v-for="(child) in  i.child" :key="child.id"  @click="toPage(child.path)" >{{ child.title }}</div>
                  </div>
                </transition>
              </div>
              
            </div>
          </transition>
        </div>
      </div>
      
    </div>
   </div>
 
   
  </div>
</template>

<script>

export default {
  data () {
    return {
      child_drawer:false,
      child_mobile_drawer:false,
      drawer:false,
      page:'',
      routeName:'',
    }
  },
  methods: {
    toPage(e){
      if(!e){
        this.child_mobile_drawer = !this.child_mobile_drawer
        return
      }
      this.drawer = false
      this.$router.push('/'+e)
    },
    getMineMenu(item){
      if(item.child){
        this.child_drawer = true
      }
    },
    removeMinMenu(item){
      if(item.child){
        this.child_drawer = false
      }
    },
  },
  created(){
   this.routeName = this.$route.name
  },
  computed:{
    menuList(){return this.$store.state.menuList}
  },
  watch: {
    '$route' (to, from) {
      let name = to.name
      this.routeName = name


    }
  },
}
</script>

<style lang="scss" >
.header{
  width:100%;
  position: relative;
  z-index: 99;
  /* pc header */
  .header_top{
    width:100%; 
    // padding:0 80px;
    height: 80px;
    margin: 0 auto;

 
    .header_logo{
     margin-right:30px;
      .header_logo_group{
        // height: 87px;
        width: 180px;
        // background:$theme_color5;
        // padding:10px 60px 10px 0px;
        // clip-path: polygon(0% 0%, 100% 0%, 70% 100%, 0% 100%);
      } 
     
      
    }
    .header_menu{
     
      .menu_list{
        // padding:30px 20px 30px 60px;
        // background:$theme_color5;
        // clip-path: polygon(100% 100%, 100% 0%, 8% 0%,0% 100%);
        .menu_tab{
            color:$theme_color1;
            font-size: 20px;
            padding:4px 15px;
            position: relative;
            // &:last-child{
            //   margin-left:20px;
            // }
            >span{
              position: absolute;
              width: 20px;
              height: 20px;
              top:calc(50% - 10px);
              // right:-6px;
              font-weight: bold;
            }
            &:hover{
              transition: all 0.3s ease;
              color:$theme_color3;
            }
            .min_menu{
              position: absolute;
              top:20px;
              left:10px;
              width: 180px;
              overflow: hidden;
              padding-top:30px;
              text-align: left;
              .min_menu_list{
                
                color:$theme_color2;
                overflow: hidden;
                
               .min_menu_tab{
                transition: all 0.3s ease;
                padding:10px 15px;
                border-radius:0 0 12px 12px;
                background:$theme_bg;
                color:$theme_color4;
                &:first-child{
                  border-radius: 12px 12px 0 0;
                  padding:10px 15px 0;
                }
                
                &:hover{
                  color:$theme_color3;

                }
               }
                
              }
            }
        }
        
      }
    }
  }
  /* mobile header */
  .mobile_header{
    height: 60px;
    // position: relative;
    .header_logo{
      width:150px;
    }
    .menu_icon{
      width:50px;
      height:50px;
      font-weight: 800;
      border-radius: 50%;
      color:$theme_color1;
      font-size: 30px;
    }
    .mobile_menu{
      position: absolute;
      top:60px;
      left:0;
      right:0;
      border-radius: 0 0 4px 4px;
      overflow: hidden;
     background:transparent;
      .mobile_menu_list{
        padding:10px;
        background: #00000090;
        
        .mobile_menu_tab{
          text-align: left;
          padding:5px 20px;
          font-size: 14px;
          
          .min_menu_list{
            padding-top:10px;
            .min_menu_tab{
              padding:5px 20px;
              opacity: 0.8;

            }
          }
        }
      }
    }
  }

}
</style>